import React, { useState } from "react";
import PropTypes from "prop-types";

import "./styles.scss";

import {
    Container,
    Row,
    Col,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    UncontrolledAccordion
} from "reactstrap";

const LearningModule = ({ modules, bgColor }) => {
    const [open, setOpen] = useState('');

    const handleAccordion = (id) => {
        if (open === id) {
            setOpen('');
        } else {
            setOpen(id);
        }
    };

    return (
        <Container fluid tag="section" className={`learning-module py-5 ${bgColor}`}>
            <Container className="pb-2 pb-md-5">
                <Row>
                    <Col className="text-center">
                        <h2 className="title">Curriculum académico</h2>
                    </Col>
                </Row>
                <Row className="pt-5">
                    {modules.map((module, i) => (
                        <Col tag="article" lg="6" key={i} className="learning-module__item">
                            <h4>{module.moduleTitle}</h4>
                            <UncontrolledAccordion flush toggle={() => handleAccordion(i)}>
                                <AccordionItem>
                                    <AccordionHeader targetId={i}>
                                        {module.title}
                                    </AccordionHeader>
                                    <AccordionBody accordionId={i}>
                                        {module.content && (
                                            <ul>
                                                {module.content.map((item, i) => (
                                                    <li key={i}>{item}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </AccordionBody>
                                </AccordionItem>
                            </UncontrolledAccordion>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    );
};

LearningModule.propTypes = {
    modules: PropTypes.arrayOf(PropTypes.object).isRequired,
    bgColor: PropTypes.string.isRequired,
};

export default LearningModule;